import SEOClient from '@/services/clients/seo-client';

export default {
  namespaced: true,
  state: () => ({
    localeReady: false,
    wsConnected: false,
    otherCryptos: [],
    selectedMarket: null,
    selectedFiatCurrency: null,
    selectedCryptoCurrency: null,
    selectedTimeInterval: null,
    tradeInfo: [],
    availableCryptoCurrencies: [],
    availableFiatCurrencies: [],
    historicalData: [],
    marketInfo: null,
    description: '',
    isPublicPage: true,
    isCorporateAccount: false,
    defaultBuyLink: null,
    defaultSellLink: null,
  }),
  mutations: {
    setAsMemberPage(state) {
      state.isPublicPage = false;
    },
    setAvailableFiatCurrencies (state, fiatCurrencies) {
      state.availableFiatCurrencies = fiatCurrencies;
    },
    setCryptoInfo (state, cryptoList) {
      state.availableCryptoCurrencies = cryptoList;
      const supportedCrypto = cryptoList
        .find((crypto) => crypto.code === state.selectedCryptoCurrency.code);
      state.selectedCryptoCurrency.links = supportedCrypto.links || {};
      state.selectedCryptoCurrency.ws = supportedCrypto.ws;
    },
    setDescription (state, description) {
      state.description = description;
    },
    setDetails (state, { marketInfo, otherCryptosList, fiatCurrency, market }) {
      state.marketInfo = marketInfo;
      state.otherCryptos = otherCryptosList.map((otherCrypto) => {
        if (state.availableCryptoCurrencies.length > 0) {
          const crypto = state.availableCryptoCurrencies
            .find((availableCrypto) => availableCrypto.code === otherCrypto.code);
          otherCrypto.slug = crypto.slug;
          otherCrypto.name = crypto.name;
        }

        return otherCrypto;
      });
      state.selectedFiatCurrency = fiatCurrency;
      state.selectedMarket = market;
    },
    setHistoricalData (state, { historicalData, timePeriod }) {
      state.historicalData = historicalData;
      state.selectedTimeInterval = timePeriod;
    },
    setLocaleReady (state, payload) {
      state.localeReady = payload;
    },
    setMarket (state, payload) {
      state.selectedMarket = payload;
    },
    setFiatCurrency (state, payload) {
      state.selectedFiatCurrency = payload;
    },
    setCryptoCurrency (state, payload) {
      state.selectedCryptoCurrency = payload;
    },
    setTimeInterval (state, payload) {
      state.selectedTimeInterval = payload;
    },
    setChartYaxisOffset (state, payload) {
      state.chartYaxisOffset = payload;
    },
    setTradeInfo (state, payload) {
      state.tradeInfo = payload;
    },
    SOCKET_RECONNECT (state) {
      state.wsConnected = true;
    },
    SOCKET_ONOPEN (state) {
      state.wsConnected = true;
    },
    SOCKET_ONCLOSE (state) {
      state.wsConnected = false;
    },
    SOCKET_ONMESSAGE (state, records) {
      state.otherCryptos.forEach((cryptoCurrency) => {
        const newPriceData = records[cryptoCurrency.code] || false;
        if (!newPriceData) {
          return;
        }
        cryptoCurrency.chg24h = newPriceData.chg24h || cryptoCurrency.chg24h;
        cryptoCurrency.price = newPriceData.price || cryptoCurrency.price;
      });
      const currentCryptoPrice = records[state.selectedCryptoCurrency.code] || false;
      if (!currentCryptoPrice || !state.marketInfo) {
        return;
      }
      state.marketInfo.chg24h = currentCryptoPrice.chg24h || state.marketInfo.chg24h;
      state.marketInfo.price = currentCryptoPrice.price || state.marketInfo.price;
    },
    SOCKET_ONERROR (state, event) {
      console.error(event);
    },
    setIsCorporateAccount (state, payload) {
      state.isCorporateAccount = payload;
    },
    setDefaultBuyLink (state, payload) {
      state.defaultBuyLink = payload;
    },
    setDefaultSellLink (state, payload) {
      state.defaultSellLink = payload;
    },
  },
  actions: {
    requestAvailableFiats ({ commit }) {
      return SEOClient.getAvailableFiatCurrencies()
        .then((fiats) => {
          commit('setAvailableFiatCurrencies', fiats);
        });
    },

    requestCryptoInfo ({ commit }) {
      return SEOClient
        .getAvailableCryptoCurrencies()
        .then((cryptos) => {
          commit('setCryptoInfo', cryptos);
        });
    },

    requestDescription ({ state, commit }, language) {
      return SEOClient
        .getDescription(state.selectedCryptoCurrency.code, language)
        .then((description) => {
          return commit('setDescription', description);
        });
    },

    requestMarketInfo ({ state, commit }, { market, fiatCurrency }) {
      return SEOClient
        .getDetails(
          market.value,
          state.selectedCryptoCurrency.code,
          fiatCurrency.code,
        ).then(({ marketInfo, otherCryptosList }) => {
          return commit('setDetails', {
            marketInfo,
            otherCryptosList,
            market,
            fiatCurrency,
          });
        });
    },

    requestHistoricData ({ state, commit }, { timePeriod, market, fiatCurrency }) {
      return SEOClient.getHistoricData(
        market.value,
        state.selectedCryptoCurrency.code,
        fiatCurrency.code,
        timePeriod.period,
      ).then((historicalData) => {
        return commit('setHistoricalData', {
          historicalData,
          timePeriod,
        });
      });
    },
  },
};
